import { Grid, Typography } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import { ButtonOutlined } from '../../../../components/button/ButtonCustoms'
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { routeName } from '../../../../routes/routeName';
import { CardOnlineCourses } from '../online-courses';
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice';
import { PublishOnlineCourseApi } from '../../../../api/publish-online-course/publish-online-course.api';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next'

export default function MostPopular(props: any) {
    const { t } = useTranslation();
    const navigate: NavigateFunction = useNavigate();
    const dispatch = useDispatch();
    const { search, type } = props
    const [data, setData] = useState<any[]>([{}]);
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("MOST_POPULAR");
    const [sortType, setSortType] = useState<string>("ASC");

    const loadData = useCallback(async () => {
        dispatch(setLoading());

        try {
            let condition: any = {};
            if (page) condition = { ...condition, page: page };
            if (pageLimit) condition = { ...condition, limit: pageLimit };
            if (search) condition = { ...condition, keyword: search };
            if (type !== 'ALL') condition = { ...condition, id_type: type };
            if (sortBy) condition = { ...condition, sort: sortBy };

            const res = await PublishOnlineCourseApi.list(condition);
            const data = res.data
            if (data?.status < 300) {
                setData(data?.data.items);
                setPage(data?.data?.meta.currentPage)
                setTotalItems(data?.data?.meta?.totalItems)
                dispatch(unsetLoading());
            } else {
                dispatch(unsetLoading());
            }
        } catch (error) {
            dispatch(unsetLoading());
        }
    }, [page, pageLimit, sortBy, search, type]);

    useEffect(() => {
        loadData();
    }, [loadData]);
    return (
        <>
            <div className="w-full flex justify-between gap-4 mt-[40px]">
                <div>
                    <Typography variant='h5'>{t("คอร์สยอดนิยม")}</Typography>
                    <Typography>{t("คอร์สมาใหม่จาก IBSC กรุณาเลือกรายการที่ต้องการ")}</Typography>
                </div>
                <div>
                    <ButtonOutlined
                        onClick={() => {
                            navigate(routeName.students.ListOnlineCourse)
                        }}
                        buttonName={t("ดูทั้งหมด")}
                        btnProps={{
                            width: "100px"
                        }}
                    /></div>
            </div>
            <section className="w-full mt-10">
                <Grid container spacing={2}>
                    {data?.map((item: any, index: number) => {
                        return (
                            <Grid item lg={12 / 6} key={index}>
                                <CardOnlineCourses item={item} getData={loadData}/>
                            </Grid>
                        )
                    })}

                </Grid>
            </section>
        </>
    )
}
